<template>
  <v-dialog v-model="captureScheduleDetailsDailog" width="1100" persistent>
    <v-card class="popup add_store_popup" style="padding-bottom:2px">
      <!-- HEADING  -->
      <div>
        <h2 class="page-title-bar" style="margin-bottom: 14px !important; float:left">
          <img src="@/assets/img/camera.png" style="margin-right: 10px; width:30px;" />{{ $t("Capture Schedule Setting")
          }}
        </h2>
        <div style="float:right">{{ `Timezone : ${storeTimeZone}` }}</div>
      </div>
      <div style="clear:both"></div>
      <v-row>
        <!-- {{ dataItem }} -->
        <v-col cols="12">
          <v-toolbar flat style="height:50px">
            <template v-slot:extension>
              <v-tabs v-model="tab" background-color="#001e38" color="#fff" grow style="margin-top: -135px" @change="handleTabChange">
                <v-tabs-slider></v-tabs-slider>
                <!-- <v-tab
                  href="#tab-1st"
                  style="border-top-left-radius: 10px"
                  ref="tab1"
                >
                  <span>{{ $t("ROG") }}</span>
                </v-tab> -->
                <v-tab href="#tab-2nd" style="border-top-right-radius: 10px" @click="checkRogHasData($event)" ref="tab2">
                  <span>{{ $t("Shelf Status") }}</span>
                </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tab" style="padding: 20px; height: 60vh; overflow-y: auto;">
            <v-tab-item :value="'tab-1st'" :transition="false" :reverse-transition="false" v-if="tab === 'tab-1st'">
              <div class="d-flex justify-space-between mt-4">
                <div class="w-100">
                  <div class="row my-3 mx-0">
                    <div style="width: 190px; display: inline-flex;">
                      <v-menu v-model="pickStartDate" :close-on-content-click="false" transition="scale-transition"
                        offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="startDate" @click:clear="startDate = ''" label="Start Time"
                            v-bind="attrs" v-on="on" :placeholder="`${$t('Select Start Date')}`"
                            class="form-input mr-3 col mandatoryv2" style="padding-top: 0px" outlined dense clearable
                            hide-details readonly prepend-icon="" append-icon="mdi-calendar-month" ref="startDate"
                            :disabled="rogTableData.length > 0"
                            @click:append="$refs.startDate.$el.querySelector('input').click()">
                          </v-text-field>
                        </template>
                        <!-- @change="checkselectedDate" -->
                        <v-date-picker v-model="startDate"  @input="pickStartDate = false"
                          no-title :min="minDate()"></v-date-picker>
                      </v-menu>
                    </div>
                    <div style="width: 190px; display: inline-flex;">
                      <v-select v-model="startHour" :items="hourList" outlined dense class="ml-3" hide-details>
                      </v-select>
                      <div style="margin: 7px 0 0 5px">
                        <p>:</p>
                      </div>
                      <v-select v-model="startMin" :items="minList" outlined dense class="ml-3" hide-details>
                      </v-select>
                    </div>
                  </div>
                  <div class="row my-3 mx-0">
                    <v-col cols="11">
                      <small class="textHeaings">Repeat *</small>
                      <div class="row align-center">
                        <div v-for="(item, i) in getWeekDaysSelectedRog" :key="i" class="cart-size" :class="item.selected ? 'active-day' : 'not-active-day'
                          " @click="selectAssignFunctionRog(item, i)">
                          <small> {{ item.name }}</small>
                        </div>
                        <v-select v-model="shelfGroupIntervalROG" :items="shelfGroupIntervalList" outlined
                          placeholder="Shelf Group Interval" dense class="form-input mx-16 col mandatoryv2 pt-0"
                          label="Shelf Group Interval" hide-details style="max-width: 162px;" :disabled="rogTableData.length > 0">
                        </v-select>
                      </div>
                    </v-col>
                  </div>
                </div>
                <div class="btn">
                  <v-btn text icon height="77% !important" @click="addRogCaptureDetails" width="150"
                    class="btn my-3 custom-btn">{{ $t("Add") }}</v-btn>
                </div>
              </div>

              <div class="RogTable">
                <v-data-table :headers="rogTableHeader" :items="rogTableData" :hide-default-footer="true"
                  disable-pagination item-key="srNo" :items-per-page="20" class="tbl-type01 row-class"
                  :single-select="false" :show-select="false" :height="'300px'">
                  <!-- NO DATA MESSAGE  -->
                  <template slot="no-data">
                    <v-alert dense color="#697A8A" class="ma-0" style="line-height: 19px">
                      <v-icon class="mr-1" color="#fff">mdi-alert-outline</v-icon>
                      {{ $t("No data available") }}</v-alert>
                  </template>
                  <template v-slot:[`item.startTime`]="{ item }">
                    <div v-if="item.startTime && item.startTime.length > 0">
                      <div v-for="time in item.startTime" :key="time">{{
                        time ? time : "-"
                        }}</div>

                    </div>
                  </template>
                  <template v-slot:[`item.endTime`]="{ item }">
                    <span>{{
                      item.endTime
                      }}</span>
                  </template>
                  <template v-slot:[`item.delete`]="{ item }">
                    <span><v-icon color="red" class="pointer" @click="deleteItem(item)">mdi-close-circle</v-icon></span>
                  </template>
                </v-data-table>

              </div>
            </v-tab-item>
            <v-tab-item :value="'tab-2nd'" :transition="false" :reverse-transition="false" v-if="tab === 'tab-2nd'">
              <div class="d-flex justify-space-between mt-4">
                <div>
                  <div class="row my-3 mx-0">
                    <div style="width: 190px; display: inline-flex;">
                      <v-menu v-model="pickStartDate1" :close-on-content-click="false" transition="scale-transition"
                        offset-y min-width="290px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field v-model="startDate1" @click:clear="startDate1 = ''" label="Start Time"
                            v-bind="attrs" v-on="on" :placeholder="`${$t('Select Start Date')}`"
                            class="form-input mr-3 col mandatoryv2" style="padding-top: 0px" outlined dense clearable
                            hide-details readonly prepend-icon="" append-icon="mdi-calendar-month" ref="startDate1"
                            @click:append="$refs.startDate1.$el.querySelector('input').click()"
                            :disabled="shelfStatusTableData.length >= 1">
                          </v-text-field>
                        </template>
                        <!-- @change="checkselectedDate" -->
                        <v-date-picker v-model="startDate1"  @input="pickStartDate1 = false"
                          no-title :min="minDate()"></v-date-picker>
                      </v-menu>
                    </div>
                    <div style="width: 190px; display: inline-flex;">
                      <v-select v-model="startHour1" :items="hourList" outlined dense class="ml-3" hide-details>
                      </v-select>
                      <div style="margin: 7px 0 0 5px">
                        <p>:</p>
                      </div>
                      <v-select v-model="startMin1" :items="minList" outlined dense class="ml-3" hide-details>
                      </v-select>
                    </div>
                    <div style="margin: 7px 0 0 5px">
                      <p>~</p>
                    </div>
                    <div style="width: 190px; display: inline-flex;">
                      <v-select v-model="endHour1" :items="hourList" outlined dense class="ml-3" hide-details>
                      </v-select>
                      <div style="margin: 7px 0 0 5px">
                        <p>:</p>
                      </div>
                      <v-select v-model="endMin1" :items="minList" outlined dense class="ml-3" hide-details>
                      </v-select>
                    </div>
                    <div style="width: 90px; display: inline-flex;">
                      <v-select v-model="selectedInterval" :items="intervalList" outlined placeholder="Select Interval"
                        dense class="form-input ml-3 col mandatoryv2 pt-0 w-25" label="Interval" hide-details>
                      </v-select>
                    </div>
                  </div>
                  <div class="row my-3 mx-0">
                    <v-col cols="11">
                      <small class="textHeaings">Repeat *</small>
                      <div class="row align-center">
                        <div v-for="(item, i) in getWeekDaysSelected" :key="i" class="cart-size" :class="item.selected ? 'active-day' : 'not-active-day'
                          " @click="selectAssignFunction(item, i)">
                          <small> {{ item.name }}</small>
                        </div>
                        <v-select v-model="shelfGroupIntervalStatus" :items="shelfGroupIntervalList" outlined
                          placeholder="Shelf Group Interval" dense class="form-input mx-16 col mandatoryv2 pt-0"
                          label="Shelf Group Interval" hide-details style="max-width: 162px;" :disabled="shelfStatusTableData.length > 0" />
                      </div>

                    </v-col>
                  </div>
                </div>
                <div class="btn">
                  <v-btn text icon height="77% !important" @click="addShelfStatusDetails" width="150"
                    class="btn my-3 custom-btn" :disabled="isDisable">{{ $t("Add") }}</v-btn>
                </div>
              </div>

              <div class="RogTable">
                <v-data-table :headers="shelfStatusTableHeader" :items="shelfStatusTableData"
                  :hide-default-footer="true" disable-pagination item-key="srNo" :items-per-page="20"
                  class="tbl-type01 row-class" :single-select="false" :show-select="false" :height="'300px'">
                  <!-- NO DATA MESSAGE  -->
                  <template slot="no-data">
                    <v-alert dense color="#697A8A" class="ma-0" style="line-height: 19px">
                      <v-icon class="mr-1" color="#fff">mdi-alert-outline</v-icon>
                      {{ $t("No data available") }}</v-alert>
                  </template>
                  <template v-slot:[`item.time`]="{ item }">
                    <div class="mb-1" style="display: grid;"><span v-for="(time, index) in item.time" :key="`${time.startTime}-${time.endTime}-${index}`">
                        {{ time.startTime }} ~ {{ time.endTime }}</span></div>
                  </template>
                  <template v-slot:[`item.interval`]="{ item }">
                    <div class="mb-1" style="display: grid;"><span v-for="(time, index) in item.interval" :key="`${time.startTime}-${time.endTime}-${index}`">
                        {{ time }} </span></div>
                  </template>
                  <template v-slot:[`item.delete`]="{ item }">
                    <div class="mb-1" style="display: grid;"><span>
                        <v-icon color="red" class="pointer" @click="deleteShelfItem(item)">mdi-close-circle</v-icon>
                      </span></div>
                    <!-- <span
                      ><v-icon
                        color="red"
                        class="pointer"
                        @click="deleteItem(item)"
                        >mdi-close-circle</v-icon
                      ></span -->
                    <!-- > -->
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>

      <v-card-actions class="d-flex position-relative justify-center pb-2 mr-2 mt-0">
          <!-- <v-btn text icon @click="saveConfigurationForCurrentPage()" class="btn mr-2 position-absolute left-0">{{ $t("Page Change") }}</v-btn> -->
          <v-btn text icon @click="saveConfiguration()" class="btn">{{
            $t("Save")
            }}</v-btn>
          <v-btn text icon @click="closeModal()" class="btn ml-2">{{
            $t("Close")
            }}</v-btn>
      </v-card-actions>
    </v-card>
    <!--Confirm Dialog -->
    <v-dialog v-model="dialogConfirm" width="400" persistent>
      <v-card class="popup add_store_popup" align="center" justify="center">
        <v-row>
          <v-col>
            <span v-text="confirmMessageText"></span>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-center">
          <v-btn text icon @click="moveTap('Yes')" class="btn">{{
            $t("Yes")
            }}</v-btn>
          <v-btn text icon @click="moveTap('No')" class="btn">{{
            $t("No")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="sortedConfirm" width="400" persistent>
      <v-card class="popup add_store_popup" align="center" justify="center">
        <v-row>
          <v-col>
            <span>The given dates are not sorted. Do you want to sort the
              date?</span>
          </v-col>
        </v-row>
        <v-card-actions class="d-flex justify-center">
          <v-btn text icon @click="sort('Yes')" class="btn">{{
            $t("Yes")
            }}</v-btn>
          <v-btn text icon @click="sort('No')" class="btn">{{
            $t("No")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import Pagenation from '@/mixins/Pagenation'
import commons from '@/plugins/commons'
import { mapGetters } from 'vuex'
import EventBus from '@/plugins/eventBus'
import codes from '@/plugins/codes'
import moment from 'moment-timezone'

export default {
  mixins: [Pagenation],
  props: {
    captureScheduleDetailsDailog: {
      type: Boolean,
      default: false
    }
    // captureScheduleSettingData: {
    //   type: Object
    // }
  },
  data () {
    return {
      shelfGroupIntervalList: Array.from({ length: 10 }, (_, i) => i + 1),
      shelfGroupIntervalROG: 1,
      shelfGroupIntervalStatus: 1,
      getWeekDaysSelectedRog: [
        {
          name: 'Mon',
          selected: true
        },
        {
          name: 'Tue',
          selected: true
        },
        {
          name: 'Wed',
          selected: true
        },
        {
          name: 'Thu',
          selected: true
        },
        {
          name: 'Fri',
          selected: true
        },
        {
          name: 'Sat',
          selected: true
        },
        {
          name: 'Sun',
          selected: true
        }
      ],
      getWeekDaysSelected: [
        {
          name: 'Mon',
          selected: true
        },
        {
          name: 'Tue',
          selected: true
        },
        {
          name: 'Wed',
          selected: true
        },
        {
          name: 'Thu',
          selected: true
        },
        {
          name: 'Fri',
          selected: true
        },
        {
          name: 'Sat',
          selected: true
        },
        {
          name: 'Sun',
          selected: true
        }
      ],
      shelfList: [],
      linkedShelfManger: [],
      rogTableData: [],
      shelfStatusTableData: [],
      pickEndDate: false,
      endDate: null,
      selectedDisplay: 1,
      displayList: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      startHour: '00',
      startMin: '00',
      endHour: '00',
      endMin: '00',
      startHour1: '00',
      startMin1: '00',
      endHour1: '01',
      endMin1: '00',
      hourList: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23'
      ],
      minList: [
        '00',
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12',
        '13',
        '14',
        '15',
        '16',
        '17',
        '18',
        '19',
        '20',
        '21',
        '22',
        '23',
        '24',
        '25',
        '26',
        '27',
        '28',
        '29',
        '30',
        '31',
        '32',
        '33',
        '34',
        '35',
        '36',
        '37',
        '38',
        '39',
        '40',
        '41',
        '42',
        '43',
        '44',
        '45',
        '46',
        '47',
        '48',
        '49',
        '50',
        '51',
        '52',
        '53',
        '54',
        '55',
        '56',
        '57',
        '58',
        '59'
      ],
      selectedInterval: 10,
      intervalList: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170, 180, 190, 200,
        310, 320, 330, 340, 350, 360],
      tab: 'tab-1st',
      repeatscheduleList: [],
      repeatScheduleData: [],
      labelCodes: [],
      scheduleList: [],
      repeatScheduleList: [],
      tempRepeatData: {
        displayPage: '1',
        endTimeOffset: 1,
        interval: null
      },
      tempRogData: {
        displayPage: null,
        startTime: null,
        endTime: null
      },
      startDate: null,
      startDate1: null,
      showStartDatePicker: false,
      hour: '00',
      min: '00',
      amPM: 'AM',
      pickDate: false,
      pickStartDate: false,
      pickStartDate1: false,
      selectedDate: null,
      labelImageCount: 0,
      dialogConfirm: false,
      confirmMessageText: '',
      sortedConfirm: false,
      originalTimeRange: []
    }
  },
  computed: {
    isDisable () {
      if (this.startDate1 && this.getWeekDaysSelected.filter((obj) => obj.selected).length !== 0) {
        return false
      }
      return true
    },
    ...mapGetters({ store: 'dataStore/GET_SELECTED_STORE' }),

    isScheduleHasEditOpen () {
      return this.scheduleList.some(item => item.edit === true)
    },

    isRepeatScheduleHasEditOpen () {
      return this.repeatScheduleList.some(item => item.edit === true)
    },
    storeTimeZone () {
      return this.$store.state.dataStore.timezone
    },
    rogTableHeader () {
      return [
        {
          text: this.$t('#'),
          sortable: false,
          value: 'srNo'
        },
        {
          text: this.$t('CAPTURE TIME'),
          sortable: false,
          value: 'startTime'
        },
        {
          text: this.$t('REPEAT DAY'),
          sortable: false,
          value: 'repeatDay'
        },
        {
          text: this.$t('GROUP INTERVAL'),
          sortable: false,
          value: 'groupInterval'
        }, {
          text: '',
          sortable: false,
          value: 'delete'
        }
      ]
    },
    shelfStatusTableHeader () {
      return [
        {
          text: this.$t('#'),
          sortable: false,
          value: 'srNo'
        },
        {
          text: this.$t('DAY'),
          sortable: false,
          value: 'day'
        },
        {
          text: this.$t('TIME'),
          sortable: false,
          value: 'time'
        },
        {
          text: this.$t('INTERVAL'),
          sortable: false,
          value: 'interval'
        },
        {
          text: this.$t('GROUP INTERVAL'),
          sortable: false,
          value: 'groupInterval'
        },
        {
          text: '',
          sortable: false,
          value: 'delete'
        }
      ]
    }
  },
  watch: {

    shelfGroupDetailsDailog (val) {
      console.log(val)
      if (val) {
        this.expand = false
        this.getShelfGroupDetails()
      }
    },
    captureScheduleDetailsDailog (val) {
      if (val === false) {
        this.scheduleList = []
        this.repeatScheduleList = []
        this.tab = 'tab-1st'
      }
    }
  },
  mounted () {
    this.getMaxImageCount()
    if (this.captureScheduleDetailsDailog) {
      this.startDate = this.getFormatDate(new Date())
      this.startDate1 = this.getFormatDate(new Date())
    }
  },

  methods: {
    getLocalDate (date) {
      return commons.convertToLocalTime(date)
    },
    minDate () {
      return this.getFormatDate(new Date())
    },
    getFormatDate (date) {
      var year = date.getFullYear()
      var month = 1 + date.getMonth()
      month = month >= 10 ? month : '0' + month
      var day = date.getDate()
      day = day >= 10 ? day : '0' + day
      return year + '-' + month + '-' + day
    },
    closeModal () {
      this.$emit('closeModalCapture', this.captureScheduleDetailsDailog)
    },
    hasDateTimePassed (dateTimeStr) {
      const currentDateTime = moment().tz(this.storeTimeZone)
      // Parse the given date-time string
      const parsedDateTime = moment(dateTimeStr, 'YYYY-MM-DD A hh:mm')

      // Compare the parsed date-time with the current date-time
      return parsedDateTime.isBefore(currentDateTime)
    },

    validateTime (repeatTime, timeArray) {
      for (const day of timeArray) {
        for (const time of day.time) {
          if (time.startTime === repeatTime.startTime && time.endTime === repeatTime.endTime) {
            return false // The same time interval is found
          }
        }
      }
      return true // No matching time interval found
    },
    addShelfStatusDetails () {
      console.log(this.shelfStatusTableData)
      if (this.shelfStatusTableData.length >= 20) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Please save the existing list'),
          'error'
        )
        return
      }

      const c1 = new Date(this.startDate1 + ' ' + this.startHour1 + ':' + this.startMin1).getTime()
      const c2 = new Date(this.startDate1 + ' ' + this.endHour1 + ':' + this.endMin1).getTime()
      console.log(this.startDate1 + ' ' + this.startHour1 + ':' + this.startMin1)
      console.log(this.startDate1 + ' ' + this.endHour1 + ':' + this.endMin1)
      console.log(c1, c2)
      if (c1 >= c2) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Given Time is not proper. End time should be always greater than start time..'),
          'error'
        )
        return
      }
      var repeatTime = {
        startTime: this.startHour1 + ':' + this.startMin1, // Removed space around colon
        endTime: this.endHour1 + ':' + this.endMin1 // Removed space around colon
      }
      if (!this.validateTime(repeatTime, this.shelfStatusTableData)) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Time interval already exists in the repeat scheduled.'),
          'error'
        )
        return
      }

      const existingTimes = this.shelfStatusTableData.flatMap(
        item => item.time || []
      )

      if (this.hasTimeOverlap(repeatTime, existingTimes)) {
        EventBus.$emit(
          'messageAlert',
          this.$t('The selected time overlaps with an existing schedule.'),
          'error'
        )
        return
      }

      const data = {
        startDate: this.startDate1,
        repeatTime: repeatTime,
        interval: this.selectedInterval,
        repeatDays: this.getWeekDaysSelected.filter((obj) => obj.selected)
      }

      if (this.shelfStatusTableData.length === 0) {
        if (data.repeatDays.length > 0) {
          for (var i = 0; i < data.repeatDays.length; i++) {
            this.shelfStatusTableData.push({
              srNo: i + 1,
              date: data.startDate,
              day: data.repeatDays[i].name,
              interval: [data.interval],
              time: [data.repeatTime],
              groupInterval: this.shelfGroupIntervalStatus
            })
          }
        }
      } else if (this.shelfStatusTableData.length > 0) {
        for (let j = 0; j < data.repeatDays.length; j++) {
          if (this.shelfStatusTableData.find((obj) => obj.day === data.repeatDays[j].name) === undefined) {
            this.shelfStatusTableData.push({
              srNo: this.shelfStatusTableData.length + 1,
              date: data.startDate,
              day: data.repeatDays[j].name,
              interval: [data.interval],
              time: [data.repeatTime]
            })
          } else {
            this.shelfStatusTableData.find((obj) => obj.day === data.repeatDays[j].name).interval.push(data.interval)
            // console.log(this.shelfStatusTableData.find((obj) => obj.day === data.repeatDays[j].name).time)
            this.shelfStatusTableData.find((obj) => obj.day === data.repeatDays[j].name).time.push(data.repeatTime)
          }
        }
      }

      this.shelfStatusTableData.forEach(item => {
        const schedules = item.time.map((time, index) => ({
          time,
          interval: item.interval[index]
        }))

        schedules.sort((a, b) => {
          return this.parseTime(a.time.startTime) -
            this.parseTime(b.time.startTime)
        })

        item.time = schedules.map(item => item.time)
        item.interval = schedules.map(item => item.interval)
      })

      this.shelfStatusTableData = this.sortData(this.shelfStatusTableData)

      this.startHour1 = '00'
      this.startMin1 = '00'
      this.endHour1 = '01'
      this.endMin1 = '00'
      this.selectedInterval = 10
      this.getWeekDaysSelected = this.getWeekDaysSelected.map((obj) => {
        obj.selected = true
        return obj
      })
    },

    parseTime (timeStr) {
      const [hours, minutes] = timeStr.split(':').map(part => part.trim()).map(Number)
      return new Date(1970, 0, 1, hours, minutes)
    },

    startsWithinAnotherRange (start, rangeStart, rangeEnd) {
      return start >= rangeStart && start < rangeEnd
    },

    hasTimeOverlap (newTime, existingTimes) {
      const newStart = this.parseTime(newTime.startTime)
      const newEnd = this.parseTime(newTime.endTime)

      return existingTimes.some(time => {
        const existingStart = this.parseTime(time.startTime)
        const existingEnd = this.parseTime(time.endTime)

        return (
          newStart < existingEnd &&
          newEnd > existingStart
        )
      })
    },

    formatRogData (originalData) {
      const addFiveMinutes = (timeStr) => {
        const date = new Date(timeStr)
        date.setMinutes(date.getMinutes() + 5)

        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')

        return `${hours}:${minutes}`
      }

      const formattedData = {
        scheduleData: {
          startTime: originalData[0]?.startTime?.[0] || '',
          scheduleList: []
        }
      }

      originalData.forEach(item => {
        const scheduleListItem = {
          repeatDay: item.repeatDay,
          groupInterval: item.groupInterval,
          schedule: item.startTime.map((time) => ({
            startTime: time.split(' ')[1],
            endTime: addFiveMinutes(time),
            displayPage: this.labelImageCount
          }))
        }

        formattedData.scheduleData.scheduleList.push(scheduleListItem)
      })
      return formattedData
    },

    formatShelfData (originalData) {
      const formattedData = {
        scheduleData: {
          startTime: originalData[0].date,
          scheduleList: []
        }
      }

      originalData.forEach(item => {
        const scheduleListItem = {
          repeatDay: item.day,
          groupInterval: this.shelfGroupIntervalStatus,
          schedule: []
        }

        item.time.forEach(time => {
          const interval = item.interval[0] // Assumes the first interval is to be used
          const schedule = {
            startTime: time.startTime.trim(),
            endTime: time.endTime.trim(),
            interval: interval
          }
          scheduleListItem.schedule.push(schedule)
        })

        formattedData.scheduleData.scheduleList.push(scheduleListItem)
      })

      return formattedData
    },

    sortData (data) {
      // Day order map
      const dayOrder = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }

      // Sorting function for time
      const sortTime = (a, b) => {
        // Ensure time is in HH:MM format
        const formatTime = time => time.replace(/ : /g, ':')
        return formatTime(a.startTime).localeCompare(formatTime(b.startTime))
      }

      // Sorting the data by day and then by time
      return data.sort((a, b) => {
        // Sort by day
        if (dayOrder[a.day] < dayOrder[b.day]) return -1
        if (dayOrder[a.day] > dayOrder[b.day]) return 1

        // If the same day, sort by the first time in the time array
        if (a.time[0] && b.time[0]) {
          return sortTime(a.time[0], b.time[0])
        }

        return 0
      }).map(item => {
        // Sort the times within each day
        if (item.time) {
          item.time.sort(sortTime)
        }
        return item
      })
    },

    deleteShelfItem (item, int, idx) {
      console.log(item, int, idx)
      const ind = this.shelfStatusTableData.findIndex((obj) => obj.day === item.day)
      console.log(ind)
      this.shelfStatusTableData.splice(ind, 1)
      // this.shelfStatusTableData.find((obj) => obj.day === item.day)
    },
    addRogCaptureDetails () {
      if (this.startDate === null) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Please Enter Details.'),
          'error'
        )
        return
      }
      if (this.rogTableData.length >= 20) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Please save the existing list'),
          'error'
        )
        return
      }

      const startUTCDate =
        this.startDate + ' ' + this.startHour + ':' + this.startMin
      // const endDateUTC = this.endDate + ' ' + this.endHour + ':' + this.endMin
      // console.log(this.getLocalDate(startUTCDate))

      const currentSelectedDate = moment(startUTCDate).format('YYYY-MM-DD HH:mm')
      // console.log(utcDate)
      // console.log(this.rogTableData)
      if (this.rogTableData.length > 0 && this.rogTableData.some(item => item.startTime.some(time => time === currentSelectedDate))) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Given date and time is already exists. Please try another date and time'),
          'error'
        )
        return
      }

      const givenDate = moment(startUTCDate)
      const currentDate = moment()

      if (givenDate.isBefore(currentDate)) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Selected date and time should be future date.'),
          'error'
        )
        return
      }

      const data = {
        startTime: [startUTCDate],
        endTime: [moment(startUTCDate, 'YYYY-MM-DD HH:mm').add(5, 'minutes').format('YYYY-MM-DD HH:mm')],
        displayPage: this.labelImageCount,
        groupInterval: this.shelfGroupIntervalROG
      }

      // this.rogTableData.sort((a, b) => {
      //   const dateA = new Date(a.startTime)
      //   const dateB = new Date(b.startTime)
      //   return dateA - dateB
      // })
      this.getWeekDaysSelectedRog.filter(item => item.selected).forEach((item, index) => {
        const selectedDayIndex = this.rogTableData.findIndex(obj => obj.repeatDay === item.name)
        const { startTime, endTime } = data
        if (selectedDayIndex !== -1) {
          this.rogTableData[selectedDayIndex] = { ...this.rogTableData[selectedDayIndex], startTime: [...this.rogTableData[selectedDayIndex].startTime, ...startTime], endTime: [...this.rogTableData[selectedDayIndex].endTime, ...endTime] }
        } else this.rogTableData.push({ ...data, srNo: index + 1, repeatDay: item.name })
      })
      this.rogTableData.sort((a, b) => {
        const dateA = new Date(a.startTime)
        const dateB = new Date(b.startTime)
        return dateA - dateB
      })
      this.resetAddData()
      console.log(this.rogTableData)
    },

    resetAddData () {
      // this.startDate = null
      // this.endDate = null
      this.startHour = '00'
      this.startMin = '00'
      this.getWeekDaysSelectedRog.forEach(item => { item.selected = true })
    },
    deleteItem (item) {
      const data = this.rogTableData.filter(obj => obj.srNo !== item.srNo)
      this.rogTableData = data.map((val, idx) => {
        return { ...val, srNo: idx + 1 }
      })
    },
    selectAssignFunction (item, index) {
      this.getWeekDaysSelected[index].selected = !this.getWeekDaysSelected[
        index
      ].selected
    },
    selectAssignFunctionRog (item, index) {
      this.getWeekDaysSelectedRog[index].selected = !this.getWeekDaysSelectedRog[
        index
      ].selected
    },

    addRepetScheduleList () {
      console.log(this.repeatScheduleList)
      if (this.repeatScheduleList.length > 0) {
        const currentDateTime = moment().tz(this.storeTimeZone)
        const c1 = currentDateTime.format('YYYY-MM-DD hh:mm A')

        const dateTimeStr = this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ].startTime
        console.log('Input Date:', dateTimeStr)

        const parsedDateTime = moment(
          dateTimeStr,
          'YYYY-MM-DD A hh:mm',
          this.storeTimeZone
        )
        const d1 = parsedDateTime.format('YYYY-MM-DD hh:mm A')
        console.log(c1)
        console.log(d1)
        const p1 = new Date(c1).getTime()
        const p2 = new Date(d1).getTime()

        console.log(p1)
        console.log(p2)

        if (p1 > p2) {
          EventBus.$emit(
            'messageAlert',
            this.$t(
              'The last date which you added is a past date.\nPlease remove and add a new date.'
            ),
            'error'
          )
          return
        }
      }

      this.repeatScheduleList.forEach(item => {
        item.edit = false
      })

      if (this.repeatScheduleList.length === 0) {
        const newTempRogData = {
          edit: true
        }
        this.repeatScheduleList.push(newTempRogData)
        this.repeatScheduleList[0].selectedDate = moment()
          .tz(this.storeTimeZone)
          .format('YYYY-MM-DD')
        this.repeatScheduleList[0].hour = moment()
          .tz(this.storeTimeZone)
          .format('hh')
        this.repeatScheduleList[0].amPM = moment()
          .tz(this.storeTimeZone)
          .format('A')
        this.repeatScheduleList[0].min = moment()
          .tz(this.storeTimeZone)
          .add(5, 'minutes')
          .format('mm')
        this.repeatScheduleList[0].startTime = moment()
          .tz(this.storeTimeZone)
          .add(5, 'minutes')
          .format('YYYY-MM-DD A hh:mm')
      } else {
        const newTempRogData = {
          edit: true
        }
        this.repeatScheduleList.push(newTempRogData)

        this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ].selectedDate = moment(
          this.repeatScheduleList[this.repeatScheduleList.length - 2]
            .selectedDate
        ).format('YYYY-MM-DD')
        this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ].hour = this.repeatScheduleList[
          this.repeatScheduleList.length - 2
        ].hour
        this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ].amPM = this.repeatScheduleList[
          this.repeatScheduleList.length - 2
        ].amPM
        this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ].min = parseInt(
          this.repeatScheduleList[this.repeatScheduleList.length - 2].min
        )
        this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ].startTime = moment(
          this.repeatScheduleList[this.repeatScheduleList.length - 2].startTime,
          'YYYY-MM-DD A hh:mm'
        )
          .add(1, 'minutes')
          .format('YYYY-MM-DD A hh:mm')

        const previousEntry = this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ]
        const newEntry = this.repeatScheduleList[
          this.repeatScheduleList.length - 1
        ]

        let newMinutes = parseInt(previousEntry.min) + 1
        let newHour = parseInt(previousEntry.hour)
        let ampm = previousEntry.amPM

        if (newMinutes > 59) {
          newMinutes = 0
          newHour += 1
          if (newHour === 13) {
            newHour = 1
            ampm = 'AM'
          }

          if (newHour >= 12) {
            ampm = 'PM'
          }
        }

        newEntry.selectedDate = moment(previousEntry.selectedDate).format(
          'YYYY-MM-DD'
        )
        newEntry.hour = newHour.toString().padStart(2, '0')
        newEntry.amPM = ampm
        newEntry.min = newMinutes.toString().padStart(2, '0')

        const newStartTime = moment(
          previousEntry.startTime,
          'YYYY-MM-DD A hh:mm'
        )
          .add(1, 'minutes')
          .format('YYYY-MM-DD A hh:mm')
        newEntry.startTime = newStartTime
      }
    },

    toggleEdit (index) {
      this.scheduleList[index].edit = !this.scheduleList[index].edit

      if (this.scheduleList[index].edit) {
        this.editedStartTime = this.scheduleList[index].startTime
      }
      var dateTime = this.editedStartTime.split(' ')
      console.log(dateTime)
      this.selectedDate = dateTime[0]
      this.scheduleList[index].amPM = dateTime[1]
      var hourMin = dateTime[2].split(':')
      this.scheduleList[index].hour = hourMin[0]
      this.scheduleList[index].min = hourMin[1]
    },

    saveRepetEdit (index) {
      if (this.repeatScheduleList[index].selectedDate === '') {
        EventBus.$emit('messageAlert', this.$t('Date is required'), 'error')
        return
      }
      if (this.repeatScheduleList[index].hour === '') {
        EventBus.$emit('messageAlert', this.$t('Hour is required'), 'error')
        return
      }
      if (this.repeatScheduleList[index].min === '') {
        EventBus.$emit('messageAlert', this.$t('minutes is required'), 'error')
        return
      }

      const d = `${this.repeatScheduleList[index].selectedDate} ${this.repeatScheduleList[index].amPM} ${this.repeatScheduleList[index].hour}:${this.repeatScheduleList[index].min}`
      this.repeatScheduleList[index].startTime = d
      this.repeatScheduleList[index].edit = false
    },
    formatDateFun (date) {
      return date ? moment(date).format('YYYY-MM-DD') : null
    },
    deleteRepeatfile (index) {
      this.repeatScheduleList.splice(index, 1)
    },

    saveConfigurationForCurrentPage () {
      this.createScheduleForPageChange()
    },

    async saveConfiguration () {
      if (this.tab === 'tab-1st') {
        await this.createSchedule()
      } else if (this.tab === 'tab-2nd') {
        await this.createRepeatSchedule()
      }
    },
    isArraySortedByStartTime (array) {
      for (let i = 0; i < array.length - 1; i++) {
        if (array[i].startTime > array[i + 1].startTime) {
          return false // Array is not sorted
        }
      }
      return true // Array is sorted
    },

    createSchedule () {
      console.log(this.rogTableData)
      const config = {
        params: {
          // company: this.$store.state.auth.user.company,
          store: this.store.code
        }
      }

      // for (let i = 0; i < this.rogTableData.length; i++) {
      //   delete this.rogTableData[i].srNo
      // }

      const reqBody = this.formatRogData(this.rogTableData)

      this.$utils
        .callAxiosWithBody(
          codes.requests.toAddSchedule.method,
          codes.requests.toAddSchedule.url,
          reqBody,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t('Success'))
            this.startTime = null
            this.rogTableData = []
            this.captureScheduleDetailsDailog = false
            this.closeModal()
          } else {
            this.captureScheduleDetailsDailog = false
            this.closeModal()
          }
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg || error.response.data.responseMessage || 'An error occurred while saving the schedule.'),
            'error'
          )
          this.rogTableData = []
          console.error(error)
          this.tab = 'tab-1st'
          // this.closeModal()
        })
    },

    createScheduleForPageChange () {
      const config = {
        params: {
          store: this.store.code
        }
      }
      const startDateTime = moment().tz(this.storeTimeZone).format('YYYY-MM-DD HH:mm')
      const endDateTime = moment(startDateTime, 'YYYY-MM-DD HH:mm').add(5, 'minutes').format('YYYY-MM-DD HH:mm')
      const reqBody = {
        scheduleData: {
          startTime: startDateTime, // sortedDates[0].startTime,
          scheduleList: [{ startTime: startDateTime, endTime: endDateTime, displayPage: this.labelImageCount }]
        }
      }
      this.$utils
        .callAxiosWithBody(
          codes.requests.pageChangeSchedule.method,
          codes.requests.pageChangeSchedule.url,
          reqBody,
          config
        )
        .then(res => {
          console.log(res)
          if (res.status === 200 || res.status === 201) {
            EventBus.$emit('messageAlert', this.$t(res.data.returnMsg || 'Success'))
            this.startTime = null
            this.rogTableData = []
            this.captureScheduleDetailsDailog = false
            this.closeModal()
          } else {
            this.captureScheduleDetailsDailog = false
            this.closeModal()
          }
        })
        .catch(error => {
          EventBus.$emit(
            'messageAlert',
            this.$t(error.response.data.returnMsg || error.response.data.responseMessage || 'An error occurred while saving the schedule.'),
            'error'
          )
          this.captureScheduleDetailsDailog = false

          this.rogTableData = []
          console.error(error)
          this.tab = 'tab-1st'
          // this.closeModal()
        })
    },
    createRepeatSchedule () {
      // console.log(scheduleList)
      if (this.shelfStatusTableData.length === 0) {
        EventBus.$emit(
          'messageAlert',
          this.$t('Add atleast one  value.'),
          'error'
        )
        return
      }

      var rogData = this.formatShelfData(this.shelfStatusTableData)
      const config = {
        params: {
          store: this.store.code
        }
      }
      const reqBody = rogData
      this.$utils
        .callAxiosWithBody(
          codes.requests.toAddRepeatSchedule.method,
          codes.requests.toAddRepeatSchedule.url,
          reqBody,
          config
        )
        .then(res => {
          if (res.status === 200) {
            EventBus.$emit('messageAlert', this.$t('Success'))
            this.repeatScheduleList = []
            this.tab = 'tab-1st'
            this.closeModal()
          }
        })
        .catch(error => {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.responseMessage ===
            'BACK_DATES_IN_SCHEDULE_END_TIME_ARE_NOT_ALLOWED'
          ) {
            EventBus.$emit(
              'messageAlert',
              this.$t('Back dates in schedule end time are not allowed.'),
              'error'
            )
          } else if (error &&
            error.response &&
            error.response.data &&
            error.response.data.returnMsg && error.response.data.returnMsg.length > 0) {
            const returnMsg = error.response.data.returnMsg
            const combinedString = Array.isArray(returnMsg)
              ? returnMsg.map(obj => obj.repeatDay + '-' + obj.msg).join('\n')
              : returnMsg
            EventBus.$emit(
              'messageAlert',
              this.$t(combinedString),
              'error'
            )
          }

          // this.repeatScheduleList = []
          // this.closeModal()
        })
    },

    getMaxImageCount () {
      const url = '/api/common/property'
      this.$utils
        .callAxios('get', url)
        .then(res => {
          this.labelImageCount = res.data.aimsPortalBiz1MaxPage
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    checkRogHasData (ev) {
      if (this.scheduleList.length > 0) {
        this.confirmMessageText =
          'There is some unsaved ROG data. Do you want save?'
        this.dialogConfirm = true
      }
    },
    moveTap (text) {
      if (text === 'Yes') {
        this.dialogConfirm = false
        this.createSchedule()
      }

      if (text === 'No') {
        this.scheduleList = []
        this.tab = 'tab-2nd'
        this.dialogConfirm = false
      }
    },

    sort (type) {
      if (type === 'Yes' && this.tab === 'tab-1st') {
        this.scheduleList.sort((a, b) => {
          const timeA = moment(a.startTime, 'YYYY-MM-DD A hh:mm').format(
            'YYYY-MM-DD HH:mm'
          )
          const timeB = moment(b.startTime, 'YYYY-MM-DD A hh:mm').format(
            'YYYY-MM-DD HH:mm'
          )
          return timeA.localeCompare(timeB)
        })
        this.sortedConfirm = false
      } else if (type === 'Yes' && this.tab === 'tab-2nd') {
        this.repeatScheduleList.sort((a, b) => {
          const timeA = moment(a.startTime, 'YYYY-MM-DD A hh:mm').format(
            'YYYY-MM-DD HH:mm'
          )
          const timeB = moment(b.startTime, 'YYYY-MM-DD A hh:mm').format(
            'YYYY-MM-DD HH:mm'
          )
          return timeA.localeCompare(timeB)
        })
        this.sortedConfirm = false
      } else if (type === 'No') {
        this.sortedConfirm = false
      }
    },
    async handleTabChange (tab) {
      if (tab === 'tab-1st') {
        await this.getMaxImageCount()
        this.shelfStatusTableData = []
        this.shelfGroupIntervalStatus = 1
        this.startDate1 = null
        this.startHour1 = '00'
        this.startMin1 = '00'
        this.endHour1 = '01'
        this.endMin1 = '00'
        this.selectedInterval = 10
        this.repeatscheduleList = []
        this.repeatScheduleData = []
        this.repeatScheduleList = []
        this.getWeekDaysSelected.forEach(d => { d.selected = true })
      } else if (tab === 'tab-2nd') {
        this.rogTableData = []
        this.shelfGroupIntervalROG = 1
        this.startDate = null
        this.startHour = '00'
        this.startMin = '00'
        this.scheduleList = []
        this.getWeekDaysSelectedRog.forEach(d => { d.selected = true })
      }
    }
  }
}
</script>
<style scoped>
.position-absolute {
  position: absolute;
}

.position-relative {
  background: transparent;
  position: relative
}

.left-0 {
  left: 0
}

.box-entry {
  border: 1px solid #ddd;
  border-radius: 5px;
  overflow: hidden;
  padding: 10px;
  margin-top: 5px;
}

.box-entry table {
  width: 100%;
  border-collapse: collapse;
}

.box-entry table tr:first-child td {
  border-bottom: 1px solid #999;
}

.box-entry table tr td {
  padding: 5px 0;
}

::v-deep .v-window__container {
  height: auto;
}

.v-tabs-items {
  box-shadow: 0px -6px 10px #ddd inset;
  border: 1px solid #ccc;
  border-top: 1px solid #ffff;
  margin-top: -6px;
}

.RogTable table {
  width: 100%;
  border-collapse: collapse;
}

.RogTable table tr:first-child {
  background-color: #ddd;
}

.RogTable table tr td,
.RogTable table tr th {
  padding: 10px;
}

.label-Header {
  margin-bottom: 10px;
  display: block;
  font-size: 13px;
}

.fake-textBox {
  border: 1px solid #999;
  border-radius: 6px;
  padding: 10px 20px;
  font-size: 13px;
}

.cart-size {
  border-radius: 7px;
  text-align: center;
  margin: 5px;
  width: 55px;
  line-height: 27px;
  padding: 5px 0 5px 0;
}

.active-day {
  background-color: #001e38;
  color: #ccd2d7;
  cursor: pointer;
}

.not-active-day {
  opacity: 0.2;
  background: #ccd2d7;
  cursor: pointer;
}

.plusBtn {
  background-color: #001e38;
  color: #ccd2d7;
  text-align: center;
  cursor: pointer;
}

.plusBtn.v-btn--disabled {
  background-color: #c9cace !important;
}

.minHour {
  width: 200px;
}

::v-deep .minHour .v-input__slot {
  padding: 0 5px;
}

::v-deep .custom-btn .v-btn__content {
  height: 100% !important;
}

::v-deep .v-tabs-bar {
  border-radius: 10px 10px 0 0;
}

::v-deep ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep ::-webkit-scrollbar-track {
  background: var(--lightestgrey);
}

::v-deep ::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 5px;
}

::v-deep ::-webkit-scrollbar-thumb:hover {
  background: #c1c1c1;
}
</style>
